export enum DemoInvoiceUnit {
  Forfait = 'forfait',
  Hour = 'h',
  Kilogram = 'kg',
  Meter = 'm',
  Unit = 'u',
}
